/**
 * Centralised configuration for counting-method–dependent field names,
 * labels, and tooltips used across the results panel.
 *
 * Adding a new counting method (e.g. counting_zone) only requires a new
 * entry here — every consumer derives its behavior from this map.
 */

const COUNTING_METHODS = {
	unique_id: {
		/** Human-readable label for this counting method */
		methodLabel: 'Unique Object',
		/** Field in the time-series JSON that holds the per-frame value */
		frameField: 'count_in_frame',
		/** Field that holds the running total */
		cumulativeField: 'cumulative_count',
		chartTitle: 'Detection Count Over Time',
		tooltipFrameLabel: 'Detections in frame',
		tooltipCumulativeLabel: 'Cumulative count',
		/** Metric key that receives focused (emphasis) styling in KeyMetrics */
		focusedMetric: 'uniqueCount',
	},
	line_based: {
		methodLabel: 'Virtual Line',
		frameField: 'line_crossings_in_frame',
		cumulativeField: 'cumulative_line_crossings',
		chartTitle: 'Line Crossings Over Time',
		tooltipFrameLabel: 'Line crossings in frame',
		tooltipCumulativeLabel: 'Cumulative line crossings',
		focusedMetric: 'lineCrossNet',
	},
};

const DEFAULT_METHOD = 'unique_id';

/**
 * Returns the config object for the given counting method.
 * Falls back to `unique_id` for unknown / missing values.
 */
export const getCountingMethodConfig = method =>
	COUNTING_METHODS[method] ?? COUNTING_METHODS[DEFAULT_METHOD];
